import { COLORS } from 'helpers/globals'

export default {
  confirmButton: {
    fontSize: '1.5rem',
    marginBottom: '2rem',
    marginRight: '3rem'
  },
  rejectButton: {
    fontSize: '1.5rem',
    marginBottom: '2rem',
    marginLeft: '3rem',
    background: COLORS.quaternary,
    '&:hover': {
      background: COLORS.quaternaryHover
    }
  },
  buttonContainer: {
    textAlign: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/components/NewProjectAtLocation/style.js